import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ThemePipe } from '../../../core/pipes/theme.pipe';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-pill-tab-button',
  templateUrl: './pill-tab-button.component.html',
  styleUrls: ['./pill-tab-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, ThemePipe],
})
export class PillTabButtonComponent {
  @Input({ required: true }) label!: string;
  @Input() isSelected = true;
  @Output() clickEvent = new EventEmitter<void>();

  get pillStyles(): [string, string][] {
    const key = `filter-${this.isSelected ? 'selected' : 'unselected'}`;
    return [
      ['type', `${key}-label`],
      ['text-color', `${key}-label`],
      ['background', key],
      ['border', key],
      ['drop-shadow', key],
      ['height', key],
      ['border-radius', key],
    ];
  }

  onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.clickEvent.emit();
  }
}
